import React, { FC } from 'react';
import styles from './UserName.module.scss';
import { User } from 'esa-ui-library';
import { PROFILE_SETTINGS_URL, PropertyType, history } from '../../../../../common';

interface UserProps {
	user: PropertyType;
}

const UserName: FC<UserProps> = ({ user }): JSX.Element => {
	const onUserEdit = (id: string) => {
		history.push(`${PROFILE_SETTINGS_URL.value}/${id}`);
	};

	return (
		<section className={styles.UserName}>
			{user?.profile_image && <img className={styles.UserImage} src={user.profile_image} alt='' />}
			{!user?.profile_image && <User className={styles.UserIcon} />}
			<span className={styles.Name} onClick={() => onUserEdit(user.user_id)}>
				{user.username}
			</span>
		</section>
	);
};

export { UserName };
